import {
  fetchSingleProductPayload,
  fetchSingleProductColorPayload,
} from "../product/ProductTypes";
import {
  ProductSequenceData,
  LOAD_PRODUCT_LIST,
  LoadProductsFromCategoryAction,
  UpdateProductListSequenceAction,
  CHANGE_PRODUCT_LIST_SEQUENCE,
  UPDATE_PRODUCT_LIST_IN_STATE,
  updateProductListInStateAction,
  UpdateSequencePayload,
  GetProductListPayload,
  updateProductListSequenceModeAction,
  UPDATE_PRODUCT_LIST_SEQUENCE_MODE,
  UpdateProductInStatePayload,
  ResetProductList,
  RESET_PRODUCT_LIST,
  RESET_PRODUCT_SEQUENCE,
  UpdateNumberOfPinnedProductsAction,
  UPDATE_NUMBER_OF_PINNED_PRODUCTS,
  UpdatePinnedProductsPayload,
  UpdatePinnedProductsAction,
  CHANGE_PINNED_PRODUCTS,
  SetPinnedProductsModeAction,
  SET_PINNED_PRODUCTS_MODE,
  SetSortingRuleAction,
  SET_SORTING_RULE,
  LOAD_SORTING_LIST,
  LoadSortingRulesListFromSortAction,
  LOAD_SORTED_PRODUCTS,
  ResetProductSequence,
  REFRESH_PRODUCT,
  FETCH_PRODUCT_IDS,
  UpdateProductSequencePayload,
  UPDATE_PRODUCT_SEQUENCE,
  UpdateProductSequenceAction,
  GetProductSequencePayload,
  GET_PRODUCT_SEQUENCE,
  GetProductSequenceAction,
  FETCH_PRODUCT,
  FETCH_PRODUCTS_COLORS,
  FETCH_PREV_PRODUCT_IDS,
  FETCH_NEXT_PRODUCT_IDS,
  productColorsDataPayload,
  REFRESH_PRODUCT_COLOR,
  productColorsData,
  FETCH_WATCHED_PRODUCT_LIST,
  ADD_PRODUCT_TO_WATCH_LIST,
  WEBSOCKET_CATEGORY_SAVE_STARTED,
  WEBSOCKET_CATEGORY_SAVE_COMPLETED,
  WEBSOCKET_CATEGORY_SAVE_FAILED,
  WebSocketCategorySaveStartedAction,
  WebSocketCategorySaveCompletedAction,
  WebSocketCategorySaveFailedAction,
  addRemoveProductInWatchListPayload,
  REMOVE_PRODUCT_FROM_WATCH_LIST,
  watchProductAction,
  unWatchProductAction,
  REVERT_PRODUCT_SEQUENCE,
  RevertProductSequence,
  CANCEL_CATALOG_PAGE_LOADING,
  CATEGORY_CHANGE,
  ChangeCategoryAction,
  LOCK_PRODUCT,
  LockProductAction,
  UNLOCK_PRODUCT,
  UnLockProductAction,
  FETCH_LOCKS_FOR_CATEGORY,
  getLocksInCategoryPayload,
  GetLocksInCategoryAction,
  LocksInCategory,
  LOCK_PRODUCT_COMPLETED,
  UNLOCK_PRODUCT_COMPLETED,
  UnLockProductCompletedAction,
  LockProductCompletedAction,
  UnLockProductResponsePayload,
  RESET_LOCKS_IN_CATEGORY,
  lockUnLockProductPayload,
  lockedProductsPayload,
  unlockedProductsPayload,
  RESET_SAVED_LOCKED_UNLOCKED_PRODUCTS,
  SET_LOCKED_UNLOCKED_PRODUCTS,
  GET_CONTENT_SLOTS,
  getContentSlotsPayload,
  getContentSlotsAction,
  RESET_CONTENT_SLOTS,
  addContentSlotAction,
  addContentSlotPayload,
  ADD_CONTENT_SLOT,
  UPDATE_CONTENT_SLOT,
  updateContentSlotPayload,
  updateContentSlotAction,
  updateContentSlotStateResponse,
  updateContentSlotStateAction,
  UPDATE_CONTENT_SLOT_STATE,
  DELETE_CONTENT_SLOT,
  deleteContentSlotPayload,
  deleteContentSlotAction,
  DELETE_CONTENT_SLOT_COMPLETED,
  SET_PINNED_PRODUCTS,
  pinnedProductsPayload,
  pinnedProductsAction,
  pinnedUnPinnedProductsPayload,
  pinnedUnPinnedProductsAction,
  SET_PINNED_UNPINNED_PRODUCTS,
  RESET_STORED_PINNED_UNPINNED_PRODUCT_IDS,
  RESET_PINNED_UNPINNED_PRODUCTS,
  GET_PINNED_PRODUCTS,
  getPinnedProductsAction,
  getPinnedProductsPayload,
  DISCARD_OUT_OF_POSITION_PRODUCTS,
  discardOutOfPositionProductsPayload,
  DiscardOutOfPositionProductsAction,
  ADD_UPDATE_CONTENT_SLOT,
  addUpdateContentSlotAction,
  deleteUpdateContentSlotAction,
  DELETE_UPDATE_CONTENT_SLOT,
  FETCH_PAGE_COLOR_BADGE_DATA,
  FetchPageColorBadgeDataAction,
  SET_SELECTED_ITEMS,
  SetSelectedItemsAction,
  FETCH_PRODUCT_DETAILS_PER_PAGE,
  SET_CURRENT_PAGE,
  UPDATE_PROGRESS_CACHE,
  UpdateProgressCacheAction,
  RESET_PROGRESS_CACHE,
  LOAD_INITIAL_PRODUCTS_DETAILS,
  LoadProductsPerPagePayload,
  assignProductPositionPayload,
  AssignProductPositionAction,
  ASSIGN_PRODUCT_POSITION,
  RESET_POSITIONED_PRODUCT_IDS,
  UPDATE_PRODUCT_POSITION,
  REMOVE_PRODUCT_POSITION,
  removeProductPositionPayload,
  RemoveProductPositionAction,
  UPDATE_SORTED_PRODUCTS_POSITIONS,
  UpdateSortedProductsPositionsAction,
  updateSortedProductsPositionsPayload,
  setPreviewOptionsPayload,
  SetPreviewOptionsAction,
  SET_PREVIEW_OPTIONS,
  SET_PREVIEW_MODE,
  RESET_PREVIEW,
  SetPreviewModeAction,
  ResetPreviewAction,
  setPreviewModePayload,
  LOAD_REMAINING_PRODUCTS,
  LoadRemainingProductsAction,
  SET_REMAINING_PRODUCTS_MODAL,
  SetRemainingProductsModalAction,
  SetRemainingProductsModalPayload,
  LoadRemainingProductsPayload,
  SET_IS_NEW_CATEGORY,
  FetchInProgressRequestsSnapshotAction,
  FETCH_IN_PROGRESS_REQUESTS_SNAPSHOT,
  CHECK_CATEGORY_SAVE,
  CheckCategorySaveAction,
  CLEAR_PENDING_SAVE_REQUEST_ID,
  ClearPendingSaveRequestIdAction,
} from "./ProductListTypes";

export const changeCategory = (): ChangeCategoryAction => {
  return {
    type: CATEGORY_CHANGE,
  };
};

export const loadProductsFromCategory = (
  payload: GetProductListPayload,
): LoadProductsFromCategoryAction => {
  return {
    payload,
    type: LOAD_PRODUCT_LIST,
  };
};

export const loadProductIdsFromCategory = (payload: GetProductListPayload) => {
  return {
    payload,
    type: FETCH_PRODUCT_IDS.REQUEST,
  };
};

export const loadPreviousProductIdsFromCategory = (
  payload: GetProductListPayload,
) => {
  return {
    payload,
    type: FETCH_PREV_PRODUCT_IDS.REQUEST,
  };
};

export const loadNextProductIdsFromCategory = (
  payload: GetProductListPayload,
) => {
  return {
    payload,
    type: FETCH_NEXT_PRODUCT_IDS.REQUEST,
  };
};

export const updateProductListSequence = (
  payload: UpdateSequencePayload,
): UpdateProductListSequenceAction => {
  return {
    payload,
    type: CHANGE_PRODUCT_LIST_SEQUENCE,
  };
};
export const updateProductSequenceList = (
  payload: UpdateProductSequencePayload,
): UpdateProductSequenceAction => {
  return {
    payload,
    type: UPDATE_PRODUCT_SEQUENCE,
  };
};
export const getProductSequenceList = (
  payload: GetProductSequencePayload,
): GetProductSequenceAction => {
  return {
    payload,
    type: GET_PRODUCT_SEQUENCE,
  };
};

export const updateProductListInState = (
  payload: UpdateProductInStatePayload,
): updateProductListInStateAction => {
  return {
    payload,
    type: UPDATE_PRODUCT_LIST_IN_STATE,
  };
};

export const productLoadingCancelled = () => {
  return {
    type: CANCEL_CATALOG_PAGE_LOADING,
  };
};

export const updateProductListSequenceMode = (
  sequenceMode: number,
): updateProductListSequenceModeAction => {
  return {
    sequenceMode,
    type: UPDATE_PRODUCT_LIST_SEQUENCE_MODE,
  };
};

export const resetProductSequence = (): ResetProductSequence => {
  return {
    type: RESET_PRODUCT_SEQUENCE,
  };
};

export const resetProductList = (): ResetProductList => {
  return {
    type: RESET_PRODUCT_LIST,
  };
};

export const updateNumberOfPinnedProducts = (
  numberOfPinnedProducts: number,
): UpdateNumberOfPinnedProductsAction => {
  return {
    payload: { numberOfPinnedProducts },
    type: UPDATE_NUMBER_OF_PINNED_PRODUCTS,
  };
};

export const updatePinnedProducts = (
  payload: UpdatePinnedProductsPayload,
): UpdatePinnedProductsAction => {
  return {
    payload,
    type: CHANGE_PINNED_PRODUCTS,
  };
};

export const setPinnedProductsMode = (
  isPinnedProductsMode: boolean,
): SetPinnedProductsModeAction => {
  return {
    isPinnedProductsMode,
    type: SET_PINNED_PRODUCTS_MODE,
  };
};

export const loadSortingList = (): LoadSortingRulesListFromSortAction => {
  return {
    type: LOAD_SORTING_LIST,
  };
};

export const setSortingRule = (rule: string): SetSortingRuleAction => {
  return {
    rule,
    type: SET_SORTING_RULE,
  };
};

export const loadSortedProducts = (
  rule: string,
  selectedSortPeriod?: string,
  timeZone?: string,
  isUnmanagedProductsSupported?: boolean,
) => {
  return {
    rule,
    selectedSortPeriod,
    timeZone,
    isUnmanagedProductsSupported,
    type: LOAD_SORTED_PRODUCTS,
  };
};

export const refreshProductFromList = (payload: fetchSingleProductPayload) => {
  return {
    payload,
    type: REFRESH_PRODUCT.REQUEST,
  };
};

export const fetchSingleProductData = (payload: fetchSingleProductPayload) => {
  return {
    payload,
    type: FETCH_PRODUCT.REQUEST,
  };
};

export interface loadProductsColorsDataActionPayload {
  payload: productColorsDataPayload;
  type: typeof FETCH_PRODUCTS_COLORS;
}

export const fetchProductsColorsData = (payload: GetProductListPayload) => {
  return {
    payload,
    type: FETCH_PRODUCTS_COLORS.REQUEST,
  };
};

export const refreshProductColorFromList = (
  payload: fetchSingleProductColorPayload,
) => {
  return {
    payload,
    type: REFRESH_PRODUCT_COLOR.REQUEST,
  };
};

export function createRefreshProductColorAction(payload: productColorsData) {
  return {
    type: REFRESH_PRODUCT_COLOR.SUCCESS,
    payload,
  };
}

export const loadWatchedProductListAction = () => {
  return {
    type: FETCH_WATCHED_PRODUCT_LIST.REQUEST,
  };
};

export const addProductToWatchList = (
  payload: addRemoveProductInWatchListPayload,
): watchProductAction => {
  return {
    type: ADD_PRODUCT_TO_WATCH_LIST.REQUEST,
    payload,
  };
};

export const removeProductFromWatchList = (
  payload: addRemoveProductInWatchListPayload,
): unWatchProductAction => {
  return {
    type: REMOVE_PRODUCT_FROM_WATCH_LIST.REQUEST,
    payload,
  };
};

export const revertProductSequence = (): RevertProductSequence => {
  return {
    type: REVERT_PRODUCT_SEQUENCE,
  };
};

export const lockProduct = (
  payload: lockedProductsPayload,
): LockProductAction => {
  return {
    type: LOCK_PRODUCT.REQUEST,
    payload,
  };
};

export const unLockProduct = (
  payload: unlockedProductsPayload,
): UnLockProductAction => {
  return {
    type: UNLOCK_PRODUCT.REQUEST,
    payload,
  };
};

export const getLocksInCategory = (
  payload: getLocksInCategoryPayload,
): GetLocksInCategoryAction => {
  return {
    type: FETCH_LOCKS_FOR_CATEGORY.REQUEST,
    payload,
  };
};

export const lockProductCompleted = (
  payload: LocksInCategory,
): LockProductCompletedAction => {
  return {
    type: LOCK_PRODUCT_COMPLETED,
    payload,
  };
};

export const unlockProductCompleted = (
  payload: UnLockProductResponsePayload,
): UnLockProductCompletedAction => {
  return {
    type: UNLOCK_PRODUCT_COMPLETED,
    payload,
  };
};

export const resetLocksInCategory = () => {
  return {
    type: RESET_LOCKS_IN_CATEGORY,
  };
};

export const resetSavedLockedUnlockedProducts = () => {
  return {
    type: RESET_SAVED_LOCKED_UNLOCKED_PRODUCTS,
  };
};

export const setLockedUnlockedProducts = (
  payload: lockUnLockProductPayload,
) => {
  return {
    payload,
    type: SET_LOCKED_UNLOCKED_PRODUCTS,
  };
};

export const getContentSlots = (
  payload: getContentSlotsPayload,
): getContentSlotsAction => {
  return {
    payload,
    type: GET_CONTENT_SLOTS.REQUEST,
  };
};

export const resetContentSlots = () => {
  return {
    type: RESET_CONTENT_SLOTS,
  };
};

export const addContentSlot = (
  payload: addContentSlotPayload,
): addContentSlotAction => {
  return {
    type: ADD_CONTENT_SLOT.REQUEST,
    payload,
  };
};

export const updateContentSlotsState = (
  payload: updateContentSlotStateResponse,
): updateContentSlotStateAction => {
  return {
    type: UPDATE_CONTENT_SLOT_STATE,
    payload,
  };
};

export const updateContentSlot = (
  payload: updateContentSlotPayload,
): updateContentSlotAction => {
  return {
    type: UPDATE_CONTENT_SLOT.REQUEST,
    payload,
  };
};

export const deleteContentSlot = (
  payload: deleteContentSlotPayload,
): deleteContentSlotAction => {
  return {
    type: DELETE_CONTENT_SLOT.REQUEST,
    payload,
  };
};

export const deleteContentSlotCompleted = (
  payload: deleteContentSlotPayload,
) => {
  return {
    type: DELETE_CONTENT_SLOT_COMPLETED,
    payload,
  };
};

export const setPinnedProducts = (
  payload: pinnedProductsPayload,
): pinnedProductsAction => {
  return {
    type: SET_PINNED_PRODUCTS.REQUEST,
    payload,
  };
};

export const setPinnedUnPinnedProducts = (
  payload: pinnedUnPinnedProductsPayload,
): pinnedUnPinnedProductsAction => {
  return {
    type: SET_PINNED_UNPINNED_PRODUCTS,
    payload,
  };
};

export const getPinnedProducts = (
  payload: getPinnedProductsPayload,
): getPinnedProductsAction => {
  return {
    type: GET_PINNED_PRODUCTS.REQUEST,
    payload,
  };
};
export const resetStoredPinnedUnpinnedProductIds = () => {
  return {
    type: RESET_STORED_PINNED_UNPINNED_PRODUCT_IDS,
  };
};

export const resetPinnedUnPinnedProducts = () => {
  return {
    type: RESET_PINNED_UNPINNED_PRODUCTS,
  };
};

export const addUpdateContentSlot = (
  payload: addContentSlotPayload,
): addUpdateContentSlotAction => {
  return {
    type: ADD_UPDATE_CONTENT_SLOT,
    payload,
  };
};

export const deleteUpdateContentSlot = (
  payload: deleteContentSlotPayload,
): deleteUpdateContentSlotAction => {
  return {
    type: DELETE_UPDATE_CONTENT_SLOT,
    payload,
  };
};

export const discardOutOfPositionProducts = (
  payload: discardOutOfPositionProductsPayload,
): DiscardOutOfPositionProductsAction => {
  return {
    type: DISCARD_OUT_OF_POSITION_PRODUCTS,
    payload,
  };
};

export const fetchPageColorBadgeData = (
  payload: GetProductListPayload,
): FetchPageColorBadgeDataAction => {
  return {
    payload,
    type: FETCH_PAGE_COLOR_BADGE_DATA.REQUEST,
  };
};

export const setSelectedItems = (
  items: ProductSequenceData[],
  isDraggedItems?: boolean,
): SetSelectedItemsAction => ({
  type: SET_SELECTED_ITEMS,
  payload: { items, isDraggedItems },
});

export const loadInitialProducts = (payload: LoadProductsPerPagePayload) => {
  return {
    type: LOAD_INITIAL_PRODUCTS_DETAILS.REQUEST,
    payload,
  };
};

export const fetchProductDetailsPerPage = (
  payload: LoadProductsPerPagePayload,
) => {
  return {
    type: FETCH_PRODUCT_DETAILS_PER_PAGE.REQUEST,
    payload,
  };
};

export const setCurrentPage = (page: number) => {
  return {
    type: SET_CURRENT_PAGE,
    payload: page,
  };
};

export const updateProgressCache = (
  categoryId: string,
  page: number,
  progress: number,
): UpdateProgressCacheAction => {
  return {
    type: UPDATE_PROGRESS_CACHE,
    payload: {
      categoryId,
      page,
      progress,
    },
  };
};

export const resetProgressCache = () => {
  return {
    type: RESET_PROGRESS_CACHE,
  };
};

export const assignProductPosition = (
  payload: assignProductPositionPayload,
): AssignProductPositionAction => {
  return {
    type: ASSIGN_PRODUCT_POSITION,
    payload,
  };
};

export const resetPositionedProductIds = () => {
  return {
    type: RESET_POSITIONED_PRODUCT_IDS,
  };
};

export const updateProductsPosition = (payload: ProductSequenceData[]) => {
  return {
    type: UPDATE_PRODUCT_POSITION,
    payload,
  };
};

export const removeProductPosition = (
  payload: removeProductPositionPayload,
): RemoveProductPositionAction => {
  return {
    type: REMOVE_PRODUCT_POSITION,
    payload,
  };
};

export const updateSortedProductsPositions = (
  payload: updateSortedProductsPositionsPayload,
): UpdateSortedProductsPositionsAction => {
  return {
    type: UPDATE_SORTED_PRODUCTS_POSITIONS,
    payload,
  };
};

export const setPreviewOptions = (
  payload: setPreviewOptionsPayload,
): SetPreviewOptionsAction => {
  return {
    type: SET_PREVIEW_OPTIONS,
    payload,
  };
};

export const setPreviewMode = (
  payload: setPreviewModePayload,
): SetPreviewModeAction => {
  return {
    type: SET_PREVIEW_MODE,
    payload,
  };
};

export const resetPreview = (): ResetPreviewAction => {
  return {
    type: RESET_PREVIEW,
  };
};

export const loadRemainingProducts = (
  payload: LoadRemainingProductsPayload,
): LoadRemainingProductsAction => {
  return {
    type: LOAD_REMAINING_PRODUCTS.REQUEST,
    payload,
  };
};

export const setRemainingProductsModal = (
  payload: SetRemainingProductsModalPayload,
): SetRemainingProductsModalAction => {
  return {
    type: SET_REMAINING_PRODUCTS_MODAL,
    payload,
  };
};

export const cancelLoadRemainingProducts = () => {
  return {
    type: LOAD_REMAINING_PRODUCTS.CANCEL,
  };
};

export const setIsNewCategory = () => {
  return {
    type: SET_IS_NEW_CATEGORY,  
  };
};

// WebSocket action creators
export const websocketCategorySaveStarted = (
  categoryId: string,
): WebSocketCategorySaveStartedAction => {
  return {
    type: WEBSOCKET_CATEGORY_SAVE_STARTED,
    payload: { categoryId },
  };
};

export const websocketCategorySaveCompleted = (
  categoryId: string,
  requestId: string,
): WebSocketCategorySaveCompletedAction => {
  return {
    type: WEBSOCKET_CATEGORY_SAVE_COMPLETED,
    payload: { categoryId, requestId },
  };
};

export const websocketCategorySaveFailed = (
  categoryId: string,
  requestId: string,
  errorMessage?: string,
): WebSocketCategorySaveFailedAction => {
  return {
    type: WEBSOCKET_CATEGORY_SAVE_FAILED,
    payload: { categoryId, requestId, errorMessage },
  };
};

export const fetchInProgressRequestsSnapshot = (
  accountId: string,
): FetchInProgressRequestsSnapshotAction => {
  return {
    type: FETCH_IN_PROGRESS_REQUESTS_SNAPSHOT.REQUEST,
    payload: { accountId },
  };
};

export const checkCategorySave = (
  categoryId: string,
): CheckCategorySaveAction => ({
  type: CHECK_CATEGORY_SAVE,
  payload: { categoryId },
});

export const clearPendingSaveRequestId = (
  requestId: string,
): ClearPendingSaveRequestIdAction => {
  return {
    type: CLEAR_PENDING_SAVE_REQUEST_ID,
    payload: { requestId },
  };
};